export class BaseDto {
  id: number;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
  aclEnabled?: boolean;
  aclEntryId?: number;
}
